/*eslint-disable*/
/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
/*eslint-enable*/

// import jwt from "../../http/requests/auth/jwt/index.js";

// import firebase from "firebase/app";
// import "firebase/auth";
import router from "@/router";
import { performFetch } from '../../helpers.js'

import {
  setApplicationLocalStorageItem,
  getApplicationLocalStorageItem,
  removeApplicationLocalStorageItem,
  isValidURL,
  resolveExternalMenuUrl,
  tryOnLoginDelegator
} from "../../helpers.js";

const flattenRolesTree = (roles = []) => {
  const flattened = [];

  const traverse = currentRoles => {
    currentRoles.forEach(role => {
      if (role && role.role_hash) {
        flattened.push({
          hash: role.role_hash,
          name: role.role_name
        });
      }

      if (role && role.role_children && role.role_children.length > 0) {
        traverse(role.role_children);
      }
    });
  };

  traverse(roles);
  return flattened;
};

export default {
  moduleEdit(payload) {
    router.push(`/modules/edit/${payload}`);
  },
  loginAttempt({ dispatch }, payload) {
    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    };

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {
      // Change firebase Persistence
      // firebase
      //   .auth()
      //   .setPersistence(firebase.auth.Auth.Persistence.SESSION)

      //   // If success try to login
      //   .then(function () {
      //     dispatch("login", newPayload);
      //   })

      //   // If error notify
      //   .catch(function (err) {
      //     // Close animation if passed as payload
      //     if (payload.closeAnimation) payload.closeAnimation();

      //     payload.notify({
      //       time: 2500,
      //       title: "Error",
      //       text: err.message,
      //       iconPack: "feather",
      //       icon: "icon-alert-circle",
      //       color: "danger"
      //     });
      //   });
    } else {
      // Try to login
      dispatch("login", newPayload);
    }
  },
  setToken({ commit }, payload) {
    setApplicationLocalStorageItem("accessToken", payload);
    commit("SET_TOKEN", payload);
  },
  checkToken({ dispatch, state }) {
    if (state.token) {
      return Promise.resolve(state.token);
    }

    const token = getApplicationLocalStorageItem("accessToken");

    if (!token) {
      return Promise.reject(new Error("Invalid Token"));
    }

    dispatch("setToken", token);
    // return dispatch('loadSession', token)
    return true;
  },
  async checkSession({ state }, payload) {
    return new Promise(async (resolve, reject) => {
      // return
      // fetch(`${payload.api_url}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "check_session",
      //     parameters: {
      //       application_token: payload.app_token,
      //       session_token: payload.session_token,
      //       session_token_to_check: payload.session_token
      //     }
      //   })
      // })
      return await performFetch(payload.api_url, {
        command: "check_session",
        parameters: {
          application_token: payload.app_token,
          session_token: payload.session_token,
          session_token_to_check: payload.session_token
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  clearStorage() {
    localStorage.removeItem("web");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("role");
    localStorage.removeItem("layout");
    localStorage.removeItem("user");
    localStorage.removeItem("web");
  },

  getMenuItemDetail({ state }, payload) {
    return new Promise((resolve, reject) => {
      const itemHash = payload.hash;

      state.menu.forEach((item, index) => {
        if (item.hash === itemHash) {
          resolve(state.menu[index]);
        } else {
          if (item.hasOwnProperty("items")) {
            item.items.forEach((itemLevel2, indexLevel2) => {
              if (itemLevel2.hash === itemHash) {
                resolve(state.menu[index].items[indexLevel2]);
              } else {
                if (itemLevel2.hasOwnProperty("submenu")) {
                  itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                    if (itemLevel3.hash === itemHash) {
                      resolve(
                        state.menu[index].items[indexLevel2].submenu[
                        indexLevel3
                        ]
                      );
                    } else {
                      if (itemLevel3.hasOwnProperty("submenu")) {
                        itemLevel3.submenu.forEach(
                          (itemLevel4, indexLevel4) => {
                            if (itemLevel4.hash === itemHash) {
                              resolve(
                                state.menu[index].items[indexLevel2].submenu[
                                  indexLevel3
                                ].submenu[indexLevel4]
                              );
                            }
                          }
                        );
                      }
                    }
                  });
                }
              }
            });
          }
        }
      });
    });
  },

  getDeleteMessage({ state }, payload) {
    state.menu.forEach(item => {
      if (item.hash === payload.hash) {
        message = `Todos os itens anexados ao menu serão excluídos, caso queira preservá-los, mova-os antes de excluir. Você tem certeza que deseja excluir o menu "${payload.name}"`;
      } else {
        item.items.forEach(itemLevel2 => {
          if (
            itemLevel2.hasOwnProperty("submenu") &&
            itemLevel2.hash === payload.hash
          ) {
            message = `Todos os itens anexados ao menu serão excluídos, caso queira preservá-los, mova-os antes de excluir. Você tem certeza que deseja excluir o menu "${payload.name}"`;
          } else {
            if (itemLevel2.hasOwnProperty("submenu")) {
              itemLevel2.submenu.forEach(itemLevel3 => {
                if (
                  itemLevel3.hasOwnProperty("submenu") &&
                  itemLevel3.hash === payload.hash
                ) {
                  message = `Todos os itens anexados ao menu serão excluídos, caso queira preservá-los, mova-os antes de excluir. Você tem certeza que deseja excluir o menu "${payload.name}"`;
                }
              });
            }
          }
        });
      }
    });
  },

  async buildApplicationMenu({ commit, state, dispatch }, payload) {
    const formatted_menu = [];

    for (const item of payload) {
      // level 2

      if (item.related_items.length > 0) {
        const newItem = {
          header: item.title,
          header_en: item.title_en || null,
          icon: item.icon || "PackageIcon",
          hash: item.hash
        };

        const related_items = [];

        for (const itemTwo of item.related_items) {

          const params = itemTwo.params ? itemTwo.params : "";
          const isValidUrl = isValidURL(itemTwo.route);
          let to = null;

          if (isValidUrl && itemTwo.destination_type_id === 5) {
            to = `/modules/external-link/${btoa(encodeURIComponent(itemTwo.route))}`
          } else if (isValidUrl && itemTwo.destination_type_id === 6) {
            to = resolveExternalMenuUrl(itemTwo.route)
          } else {
            to = `${itemTwo.route}/${params}`
          }

          const newItemTwo = {
            url: to,
            name: itemTwo.title,
            name_en: itemTwo.title_en || null,
            slug: "email",
            icon: itemTwo.icon || "MailIcon",
            hash: itemTwo.hash,
            destination_type_id: itemTwo.destination_type_id
          };

          if (itemTwo.destination_type_id === 1) {
            newItemTwo["submenu"] = [];
          }

          const relatedLevelTwo = [];

          // level 3

          if (itemTwo.related_items.length > 0) {
            for (const itemThree of itemTwo.related_items) {
              const params = itemThree.params ? itemThree.params : "";
              const isValidUrl = isValidURL(itemTwo.route);
              let to = null;

              if (isValidUrl && itemThree.destination_type_id === 5) {
                to = `/modules/external-link/${btoa(itemThree.route)}`
              } else if (isValidUrl && itemThree.destination_type_id === 6) {
                to = resolveExternalMenuUrl(itemThree.route)
              } else {
                to = `${itemThree.route}/${params}`
              }
              const newItemThree = {
                url: to,
                name: itemThree.title,
                name_en: itemThree.title_en || null,
                slug: "email",
                icon: itemThree.icon || "MailIcon",
                hash: itemThree.hash,
                destination_type_id: itemThree.destination_type_id
              };

              if (itemThree.destination_type_id === 1) {
                newItemThree["submenu"] = [];
              }

              const relatedLevelThree = [];

              // level 4

              if (itemThree.related_items.length > 0) {
                for (const itemFour of itemThree.related_items) {
                  const params = itemFour.params ? itemFour.params : "";
                  const isValidUrl = isValidURL(itemFour.route)
                  const newItemFour = {
                    url: isValidUrl
                      ? `/modules/external-link/${btoa(itemFour.route)}`
                      : `${itemFour.route}/${params}`,
                    name: itemFour.title,
                    name_en: itemFour.title_en || null,
                    slug: "email",
                    icon: itemFour.icon || "MailIcon",
                    hash: itemFour.hash,
                    destination_type_id: itemFour.destination_type_id
                  };

                  relatedLevelThree.push(newItemFour);
                  newItemThree.submenu = relatedLevelThree;
                }
              }

              relatedLevelTwo.push(newItemThree);
              newItemTwo.submenu = relatedLevelTwo;
            }
          }

          related_items.push(newItemTwo);
          newItem.items = related_items;
        }

        formatted_menu.push(newItem);
      } else {
        const newItem = {
          header: item.title,
          header_en: item.title_en || null,
          icon: item.icon || "PackageIcon",
          hash: item.hash,
          items: []
        };

        formatted_menu.push(newItem);
      }
    }

    setApplicationLocalStorageItem("menu", JSON.stringify(formatted_menu));
    setApplicationLocalStorageItem(
      "menuLayout",
      JSON.stringify(formatted_menu)
    );

    commit("SET_APPLICATION_MENU", JSON.stringify(formatted_menu));

    return formatted_menu;
  },

  async handleSuccessLogin({ commit, state, dispatch }, response) {
    await dispatch("applySessionState", response);

    const shouldTryOnLoginDelegator =
      !!response.on_login_delegator_enabled &&
      !!response.user &&
      !!response.user.external_user &&
      !!response.delegator_url;

    if (shouldTryOnLoginDelegator) {
      const redirected = await tryOnLoginDelegator({
        delegatorUrl: response.delegator_url,
        applicationToken: state.app_token || getApplicationLocalStorageItem("app_token"),
        sessionToken: response.session && response.session.token,
        user: response.user,
        timeoutMs: 2000
      });

      if (redirected) {
        return;
      }
    }

    let urlToRedirect = null;

    // const lastUrl = getApplicationLocalStorageItem("lastUrl");
    const lastUrl = null;

    if (lastUrl) {
      urlToRedirect = atob(lastUrl).startsWith("/")
        ? atob(lastUrl)
        : null;
    } else {
      urlToRedirect = null;
    }

    if (response.user.change_password) {
      location.href =
        process.env.BASE_URL.slice(0, -1) + "pages/reset-password";
    } else {
      if (urlToRedirect === null) {
        urlToRedirect =
          process.env.BASE_URL.slice(0, -1) + response.role.home_url;
      }

      const resolved = router.resolve(urlToRedirect);

      if (resolved.route.name !== "page-error-404") {
        location.href = urlToRedirect;
      } else {
        urlToRedirect =
          process.env.BASE_URL.slice(0, -1) + response.role.home_url;
        location.href = urlToRedirect;
      }

      removeApplicationLocalStorageItem("lastUrl");
    }
  },
  async applySessionState({ commit, dispatch }, response) {
    response.user.permissions = response.permissions;
    dispatch("setToken", response.session.token);

    setApplicationLocalStorageItem(
      "accessToken",
      response.session.token
    );
    setApplicationLocalStorageItem(
      "layout",
      JSON.stringify(response.layout)
    );
    setApplicationLocalStorageItem("web", JSON.stringify(response.web));
    setApplicationLocalStorageItem(
      "user",
      JSON.stringify(response.user)
    );
    setApplicationLocalStorageItem(
      "role",
      JSON.stringify(response.role)
    );
    setApplicationLocalStorageItem("roleLogo", response.role.default_logo);
    setApplicationLocalStorageItem("roleLogoWidth", response.role.logo_width);
    setApplicationLocalStorageItem("roleLogoHeight", response.role.logo_height);
    setApplicationLocalStorageItem(
      "languages",
      JSON.stringify(response.languages)
    );
    setApplicationLocalStorageItem(
      "adminMenu",
      JSON.stringify(response.admin_menu)
    );
    setApplicationLocalStorageItem("delegatorUrl", response.delegator_url);

    commit("SET_USER", response.user);
    commit("SET_TOKEN", response.session.token);
    commit("SET_LAYOUT", response.layout);
    commit("SET_GENERAL", response.web);
    commit("SET_USER_ROLE", response.role);
    commit("SET_ROLE_LOGO", response.role.default_logo);
    commit("SET_ROLE_LOGO_HEIGHT", response.role.logo_height);
    commit("SET_DELEGATOR_URL", response.delegator_url);
    commit(
      "SET_APPLICATION_LANGUAGES",
      response.languages
    );
    commit("SET_ADMIN_MENU", response.admin_menu);

    const mainMenu = await dispatch(
      "buildApplicationMenu",
      response.mainmenu
    );

    setApplicationLocalStorageItem("currentUserMenu", mainMenu);
  },
  async getSwitchableRoles({ commit, state }) {
    return await performFetch(state.api_url, {
      command: "get_application_roles",
      parameters: {
        application_token: state.app_token,
        session_token: state.token
      }
    })
      .then(async response => {
        if (response.status !== 200) {
          throw new Error("Erro ao carregar cargos");
        }

        const data = await response.json();
        const roles = flattenRolesTree(data.roles || []);
        commit("SET_AVAILABLE_ROLES", roles);
        return roles;
      })
      .catch(error => {
        throw new Error(error.message || "Erro ao carregar cargos");
      });
  },
  async switchRole({ dispatch, state }, roleHash) {
    return await performFetch(state.api_url, {
      command: "switch_role",
      parameters: {
        application_token: state.app_token,
        session_token: state.token,
        role_hash: roleHash
      }
    })
      .then(async response => {
        if (response.status !== 200) {
          let message = "Erro ao trocar cargo";

          try {
            const errorData = await response.json();
            message = errorData.message || message;
          } catch (e) {}

          throw new Error(message);
        }

        const data = await response.json();
        await dispatch("applySessionState", data);
        return data.role.home_url || "/";
      })
      .catch(error => {
        throw new Error(error.message || "Erro ao trocar cargo");
      });
  },

  async login({ commit, state, dispatch }, payload) {
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    };


    return await performFetch(`${state.api_url}`, {
      command: "start_session",
      parameters: {
        application_token: state.app_token,
        username: newPayload.userDetails.email,
        password: newPayload.userDetails.password
      }
    })
      .then(async response => {
        if (response.status === 200) {
          response.json().then(async data => {
            dispatch('handleSuccessLogin', data)
          });
        } else {
          let message = "";
          await response
            .json()
            .then(async response => {
              message = response.message;
              throw new Error(response.message);
            })
            .catch(error => {
              message = error.message;
              throw new Error(error.message);
            });

          throw new Error(message);
        }
      })
      .catch(e => {
        throw new Error(e.message);
      });
  },

  async reloadState({ commit, state, dispatch }) {
    commit("SET_USER", JSON.parse(getApplicationLocalStorageItem("user")));
    commit("SET_TOKEN", getApplicationLocalStorageItem("accessToken"));
    commit("SET_API_URL", getApplicationLocalStorageItem("api_url"));
    commit("SET_DELEGATOR_URL", getApplicationLocalStorageItem("delegatorUrl"));
    commit("SET_APP_TOKEN", getApplicationLocalStorageItem("app_token"));
    commit("SET_LAYOUT", JSON.parse(getApplicationLocalStorageItem("layout")));
    commit("SET_GENERAL", JSON.parse(getApplicationLocalStorageItem("web")));
    commit("SET_USER_ROLE", JSON.parse(getApplicationLocalStorageItem("role")));
    commit("SET_ROLE_LOGO", getApplicationLocalStorageItem("roleLogo"));
    commit("SET_ROLE_LOGO_HEIGHT", getApplicationLocalStorageItem("roleLogoHeight"));
    commit(
      "SET_APPLICATION_LANGUAGES",
      JSON.parse(getApplicationLocalStorageItem("languages"))
    );
    commit(
      "SET_APPLICATION_MENU",
      JSON.parse(getApplicationLocalStorageItem("menu"))
    );
    commit(
      "SET_APPLICATION_WEB_PARAMETERS",
      JSON.parse(getApplicationLocalStorageItem("web"))
    );
    commit(
      "SET_ADMIN_MENU",
      JSON.parse(getApplicationLocalStorageItem("adminMenu"))
    );
    commit(
      "SET_MENU_LAYOUT",
      JSON.parse(getApplicationLocalStorageItem("menuLayout"))
    );
  },
  async getLoginParameters({ commit, state, dispatch }, payload) {

    return new Promise(async (resolve, reject) => {
      // fetch(`${process.env.VUE_APP_ROOT_API}`, {
      //   method: "POST", headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: "login_parameters",
      //     parameters: {
      //       application_domain:
      //         payload.source_domain + process.env.BASE_URL.slice(0, -1)
      //     }
      //   })
      // })
      await performFetch(process.env.VUE_APP_ROOT_API, {
        command: "login_parameters",
        parameters: {
          application_domain:
            payload.source_domain + process.env.BASE_URL.slice(0, -1)
        }
      })
        .then(response => {
          response.json().then(async data => {
            commit("SET_LOGIN_PARAMETERS", data.payload.login_parameters);
            setApplicationLocalStorageItem("api_url", data.payload.api_url);
            commit("SET_API_URL", data.payload.api_url);
            setApplicationLocalStorageItem("app_token", data.payload.app_hash);
            commit("SET_APP_TOKEN", data.payload.app_hash);
            setApplicationLocalStorageItem("use_microsoft_sso", data.payload.use_microsoft_sso);
            commit("SET_USE_MICROSOFT_SSO", data.payload.use_microsoft_sso);
            setApplicationLocalStorageItem("microsoft_client_id", data.payload.microsoft_client_id);
            commit("SET_MICROSOFT_CLIENT_ID", data.payload.microsoft_client_id);
            setApplicationLocalStorageItem("microsoft_tenant_id", data.payload.microsoft_tenant_id);
            commit("SET_MICROSOFT_TENANT_ID", data.payload.microsoft_tenant_id);
            setApplicationLocalStorageItem("microsoft_redirect_url", data.payload.sso_redirect_url);
            commit("SET_MICROSOFT_REDIRECT_URL", data.payload.sso_redirect_url);

            resolve(data);
          });
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  redirectToForbiddenPage() {
    router.push('/error-403')
  },
  setBreadcrumb({ }, breadcrumbData) {

  },
  setPageTitle({ }, to = null) {

  },

  async signOut({ commit, state, dispatch }) {
    // return
    // await fetch(`${state.api_url}`, {
    //   method: "POST", headers: {"Content-Type": "application/json"},
    //   body: JSON.stringify({
    //     command: "end_session",
    //     parameters: {
    //       application_token: state.app_token,
    //       session_token: state.token,
    //       session_token_to_kill: state.token
    //     }
    //   })
    // })
    return await performFetch(state.api_url, {
      command: "end_session",
      parameters: {
        application_token: state.app_token,
        session_token: state.token,
        session_token_to_kill: state.token
      }
    })
      .then(response => {
        if (response.status === 200) {
          response.json().then(async response => {
            router.push("/pages/login").catch(() => { });

            setApplicationLocalStorageItem("accessToken", "");
            removeApplicationLocalStorageItem("accessToken");
            removeApplicationLocalStorageItem("role");
            removeApplicationLocalStorageItem("roleLogo");
            removeApplicationLocalStorageItem("roleLogoWidth");
            removeApplicationLocalStorageItem("roleLogoHeight");
            removeApplicationLocalStorageItem("layout");
            removeApplicationLocalStorageItem("api_url");
            removeApplicationLocalStorageItem("app_token");
            removeApplicationLocalStorageItem("user");
            removeApplicationLocalStorageItem("web");
            removeApplicationLocalStorageItem("delegatorUrl");

            commit("SET_TOKEN", "");
            commit("SET_USER_ROLE", {});
            commit("SET_ROLE_LOGO", null);
            commit("SET_ROLE_LOGO_HEIGHT", 40);
            commit("SET_LAYOUT", {});
            commit("SET_API_URL", "");
            commit("SET_DELEGATOR_URL", "");
            commit("SET_APP_TOKEN", "");
            commit("SET_USER", {});
            commit("SET_GENERAL", {});
          });
        } else {
          router.push("/pages/login").catch(() => { });

          return new Promise(async (resolve, reject) => {
            const accessToken = getApplicationLocalStorageItem(
              "accessToken"
            );
            await performFetch(state.api_url, {
              command: "end_session",
              parameters: {
                application_token: state.app_token,
                session_token: accessToken,
                session_token_to_kill: accessToken
              }
            })
              .then(response => {
                setApplicationLocalStorageItem("accessToken", "");
                removeApplicationLocalStorageItem("accessToken");
                removeApplicationLocalStorageItem("role");
                removeApplicationLocalStorageItem("layout");
                removeApplicationLocalStorageItem("api_url");
                removeApplicationLocalStorageItem("delegatorUrl");
                removeApplicationLocalStorageItem("app_token");
                removeApplicationLocalStorageItem("user");
                removeApplicationLocalStorageItem("web");
                removeApplicationLocalStorageItem("menu");

                commit("SET_TOKEN", "");
                commit("SET_USER_ROLE", {});
                commit("SET_LAYOUT", {});
                commit("SET_API_URL", "");
                commit("SET_DELEGATOR_URL", "");
                commit("SET_APP_TOKEN", "");
                commit("SET_USER", {});
                commit("SET_GENERAL", {});
                commit("SET_APPLICATION_MAIN_MENU", {});

                throw new Error("Unauthorized");
              })
              .catch(() => {
                router.push("/pages/login").catch(() => { });


                resolve(true)
                // response.json().then(async response => {



                // });
              })
              .catch(() => {
                setApplicationLocalStorageItem("accessToken", "");
                removeApplicationLocalStorageItem("accessToken");
                removeApplicationLocalStorageItem("role");
                removeApplicationLocalStorageItem("layout");
                removeApplicationLocalStorageItem("api_url");
                removeApplicationLocalStorageItem("delegatorUrl");
                removeApplicationLocalStorageItem("app_token");
                removeApplicationLocalStorageItem("user");
                removeApplicationLocalStorageItem("web");
                removeApplicationLocalStorageItem("menu");

                commit("SET_TOKEN", "");
                commit("SET_USER_ROLE", {});
                commit("SET_LAYOUT", {});
                commit("SET_API_URL", "");
                commit("SET_DELEGATOR_URL", "");
                commit("SET_APP_TOKEN", "");
                commit("SET_USER", {});
                commit("SET_GENERAL", {});
                commit("SET_APPLICATION_MAIN_MENU", {});

                resolve(true)
              });
          })

        }

      })
  },

  // Google Login
  loginWithGoogle({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    // const provider = new firebase.auth.GoogleAuthProvider();

    // firebase
    //   .auth()
    //   .signInWithPopup(provider)
    //   .then(result => {
    //     router.push(router.currentRoute.query.to || "/");
    //     commit("UPDATE_USER_INFO", result.user.providerData[0], { root: true });
    //   })
    //   .catch(err => {
    //     payload.notify({
    //       time: 2500,
    //       title: "Error",
    //       text: err.message,
    //       iconPack: "feather",
    //       icon: "icon-alert-circle",
    //       color: "danger"
    //     });
    //   });
  },

  // Facebook Login
  loginWithFacebook({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    // const provider = new firebase.auth.FacebookAuthProvider();

    // firebase
    //   .auth()
    //   .signInWithPopup(provider)
    //   .then(result => {
    //     router.push(router.currentRoute.query.to || "/");
    //     commit("UPDATE_USER_INFO", result.user.providerData[0], { root: true });
    //   })
    //   .catch(err => {
    //     payload.notify({
    //       time: 2500,
    //       title: "Error",
    //       text: err.message,
    //       iconPack: "feather",
    //       icon: "icon-alert-circle",
    //       color: "danger"
    //     });
    //   });
  },

  // Twitter Login
  loginWithTwitter({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    // const provider = new firebase.auth.TwitterAuthProvider();

    // firebase
    //   .auth()
    //   .signInWithPopup(provider)
    //   .then(result => {
    //     router.push(router.currentRoute.query.to || "/");
    //     commit("UPDATE_USER_INFO", result.user.providerData[0], { root: true });
    //   })
    //   .catch(err => {
    //     payload.notify({
    //       time: 2500,
    //       title: "Error",
    //       text: err.message,
    //       iconPack: "feather",
    //       icon: "icon-alert-circle",
    //       color: "danger"
    //     });
    //   });
  },

  // Github Login
  loginWithGithub({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    // const provider = new firebase.auth.GithubAuthProvider();

    // firebase
    //   .auth()
    //   .signInWithPopup(provider)
    //   .then(result => {
    //     router.push(router.currentRoute.query.to || "/");
    //     commit("UPDATE_USER_INFO", result.user.providerData[0], { root: true });
    //   })
    //   .catch(err => {
    //     payload.notify({
    //       time: 2500,
    //       title: "Error",
    //       text: err.message,
    //       iconPack: "feather",
    //       icon: "icon-alert-circle",
    //       color: "danger"
    //     });
    //   });
  },
  registerUser({ dispatch }, payload) {
    // create user using firebase
    // firebase
    //   .auth()
    //   .createUserWithEmailAndPassword(
    //     payload.userDetails.email,
    //     payload.userDetails.password
    //   )
    //   .then(
    //     () => {
    //       payload.notify({
    //         title: "Account Created",
    //         text: "You are successfully registered!",
    //         iconPack: "feather",
    //         icon: "icon-check",
    //         color: "success"
    //       });

    //       const newPayload = {
    //         userDetails: payload.userDetails,
    //         notify: payload.notify,
    //         updateUsername: true
    //       };
    //       dispatch("login", newPayload);
    //     },
    //     error => {
    //       payload.notify({
    //         title: "Error",
    //         text: error.message,
    //         iconPack: "feather",
    //         icon: "icon-alert-circle",
    //         color: "danger"
    //       });
    //     }
    //   );
  },
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.displayName
      })
      .then(() => {
        // If username update is success
        // update in localstorage
        const newUserData = Object.assign({}, payload.user.providerData[0]);
        newUserData.displayName = payload.displayName;
        commit("UPDATE_USER_INFO", newUserData, { root: true });

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || "/");
        }
      })
      .catch(err => {
        payload.notify({
          time: 8800,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  // JWT
  // loginJWT({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     jwt
  //       .login(payload.userDetails.email, payload.userDetails.password)
  //       .then(response => {
  //         // If there's user data in response
  //         if (response.data.userData) {
  //           // Navigate User to homepage
  //           router.push(router.currentRoute.query.to || "/");

  //           // Set accessToken
  //           setApplicationLocalStorageItem(
  //             "accessToken",
  //             response.data.accessToken
  //           );

  //           // Update user details
  //           commit("UPDATE_USER_INFO", response.data.userData, { root: true });

  //           // Set bearer token in axios
  //           commit("SET_BEARER", response.data.accessToken);

  //           resolve(response);
  //         } else {
  //           reject({ message: "Wrong Email or Password" });
  //         }
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // },
  // registerUserJWT({ commit }, payload) {
  //   const {
  //     displayName,
  //     email,
  //     password,
  //     confirmPassword
  //   } = payload.userDetails;

  //   return new Promise((resolve, reject) => {
  //     // Check confirm password
  //     if (password !== confirmPassword) {
  //       reject({ message: "Password doesn't match. Please try again." });
  //     }

  //     jwt
  //       .registerUser(displayName, email, password)
  //       .then(response => {
  //         // Redirect User
  //         router.push(router.currentRoute.query.to || "/");

  //         // Update data in localStorage
  //         setApplicationLocalStorageItem(
  //           "accessToken",
  //           response.data.accessToken
  //         );
  //         commit("UPDATE_USER_INFO", response.data.userData, { root: true });

  //         resolve(response);
  //       })
  //       .catch(error => {
  //         reject(error);
  //       });
  //   });
  // },
  // fetchAccessToken() {
  //   return new Promise(resolve => {
  //     jwt.refreshToken().then(response => {
  //       resolve(response);
  //     });
  //   });
  // }
};
